/* eslint-disable prettier/prettier */
import { createSlice } from "@reduxjs/toolkit";

export const galeriaSlice = createSlice({
  name: "galeria",
  initialState: {
    galeria: [],
    isloadingGaleria: true,
  },
  reducers: {
    setGaleria: (state, action) => {
      state.galeria = action.payload;
      state.isloadingGaleria = false;
    },
    setGaleria: (state, action) => {
      state.galeria = action.payload;
      state.isloadingGaleria = false;
    },
    isLoadingGaleria: (state, action) => {
      state.isloadingGaleria = action.payload;
    },
    setAddGaleria: (state, action) => {
      state.galeria.unshift(action.payload);
    },
    removeGaleria: (state, action) => {
      const idGaleria = action.payload;
      state.galeria = state.galeria.filter((imagen) => imagen.idGaleria !== idGaleria);
    },
    updateLoadingDescarga: (state, action) => {
      state.galeria = state.galeria.map((item) => {
        if (item.idGaleria === action.payload.idGaleria) {
          return {
            ...item,
            loading: action.payload.valor,
          };
        }
        return item;
      });
    },
  },
});

// Action creators are generated for each case reducer function
export const { setGaleria, isLoadingGaleria, setAddGaleria, removeGaleria, updateLoadingDescarga } =
  galeriaSlice.actions;

export default galeriaSlice.reducer;
